module.exports = __webpack_public_path__ + "static/ufc-formula-183d34726fb99fd47f685fe82746906c.png";